module.exports = __webpack_public_path__ + "static/img/ai-uploade.a0765bd2.png";